export default "__VITE_ASSET__DTvzuN9g__";